import { LogManager } from '../../../common/port/log/log.manager.port';
import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { SelfWorkingSessionsEntity } from '../../../core/domain/entities/working-sessions/self-working-sessions.entity';
import { GetSelfWorkingSessionsRequestDto } from '../../dtos/working-sessions/get-self-working-sessions.request.dto';
import { GetSelfWorkingSessionsApplicationService } from '../../../core/application/services/working-sessions/get-self-working-sessions.application-service';

export class GetSelfWorkingSessionsQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfWorkingSessionsApplicationService
  ) {}
  async execute(
    props: GetSelfWorkingSessionsRequestDto
  ): Promise<SelfWorkingSessionsEntity[]> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
